import Promise from 'promise-polyfill';
import iframesPromise from './iframes';
import configPromise from './config';
import apiPromise from './api';
import { CHAT_STARTS_OPEN_LOCAL_STORAGE_KEY } from './constants';

// Keep track of whether the proactive message has been sent
let proactiveMessageSent = false;

// Keep track of whether the chat panel is open
let chatPanelOpen = false;

// We modify the <meta> viewport tag to ensure that the page doesn't scale when the webchat is
// open in mobile (full screen) mode
const viewport = document.querySelector('meta[name="viewport"]');
const initialViewportContent = viewport ? viewport.content : '';

const resetViewport = () => {
  if (!viewport) return;
  viewport.content = initialViewportContent;
};

const applyRequiredChatViewport = () => {
  const screenWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);

  if (!viewport || screenWidth >= 768) return;
  viewport.content = 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no';
};

const visibilityChangeHandler = () => {
  Promise.all([configPromise, iframesPromise, apiPromise]).then(([config, iframes, api]) => {
    chatPanelOpen = !chatPanelOpen;

    window.Ambit('visibilityChange', chatPanelOpen);
    window.parent.localStorage.setItem(CHAT_STARTS_OPEN_LOCAL_STORAGE_KEY, chatPanelOpen);

    iframes.chatWindowFrame.contentWindow.postMessage(
      { type: 'setWebChatOpenState', chatPanelOpen },
      '*'
    );
    if (config.showLauncher) {
      iframes.launcherFrame.contentWindow.postMessage(
        { type: 'setWebChatOpenState', chatPanelOpen },
        '*'
      );
    }

    if (chatPanelOpen) {
      iframes.chatWindowFrame.style.cssText = '';
      setTimeout(() => (iframes.chatWindowFrame.className = 'ambitOpen'), 50);

      if (
        !proactiveMessageSent &&
        config.proactiveMessage &&
        !config.directLine.conversationId &&
        api.queueEmpty()
      ) {
        window.Ambit('sendMessage', config.proactiveMessage);
      }
      proactiveMessageSent = true;

      if (config.showLauncher) {
        iframes.launcherWrapperDiv.className = '';
      }

      applyRequiredChatViewport();
    } else {
      iframes.chatWindowFrame.className = 'ambitClosed';
      setTimeout(() => (iframes.chatWindowFrame.style.cssText = 'display: none;'), 500);

      resetViewport();
    }

    if (config.showLauncher) {
      iframes.launcherWrapperDiv.className = '';
    }
  });
};

const openChatPanel = () => {
  if (!chatPanelOpen) {
    visibilityChangeHandler();
  }
};

const closeChatPanel = () => {
  if (chatPanelOpen) {
    visibilityChangeHandler();
  }
};

export default visibilityChangeHandler;
export { openChatPanel, closeChatPanel };



// WEBPACK FOOTER //
// ./src/initialiser/visibilityChangeHandler.js